module.exports = __webpack_public_path__ + "static/OG_Code-audit-UX-99af2331a7d50cc8c3b3f2141dd076c7.png";